import { api } from './index';
import type { ContactFormData, GenericResponse, ReferenceProject } from '@/types';

// Kontakt-Formular senden
export const contactService = {
  /**
   * Sendet die Formularinhalte als E-Mail und/oder an den Server
   * Enthält Bot-Schutz und Fehlerbehandlung
   */
  submitContactForm: async (data: ContactFormData) => {
    try {
      console.log('Kontaktformular-Daten erhalten:', data);
      
      // Integration mit getform.io
      const formData = new FormData();
      
      // Füge alle Formularfelder hinzu
      Object.entries(data).forEach(([key, value]) => {
        if (value !== undefined) {
          formData.append(key, value.toString());
        }
      });
      
      // Füge Metadaten hinzu
      formData.append('form-name', 'contact-form');
      formData.append('source', window.location.pathname);
      
      // Sende an getform.io
      const response = await fetch('https://getform.io/f/avrwvgya', {
        method: 'POST',
        body: formData,
      });
      
      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}`);
      }
      
      return {
        success: true,
        message: 'Anfrage erfolgreich übermittelt',
      };
    } catch (error) {
      console.error('Fehler beim Senden des Kontaktformulars:', error);
      return {
        success: false,
        message: 'Fehler beim Übermitteln der Anfrage. Bitte versuchen Sie es später erneut.',
      };
    }
  }
};

// Referenzen abrufen
export const referenceService = {
  getAllReferences: () => {
    return api.get<ReferenceProject[]>('/references');
  },
  
  getReferenceById: (id: string) => {
    return api.get<ReferenceProject>(`/references/${id}`);
  }
};

// Newsletter-Anmeldung
export const newsletterService = {
  subscribe: (email: string) => {
    return api.post<GenericResponse>('/newsletter/subscribe', { email });
  },
  
  unsubscribe: (email: string) => {
    return api.post<GenericResponse>('/newsletter/unsubscribe', { email });
  }
}; 